module.exports = __webpack_public_path__ + "static/media/orangecircle.f04fcc66.svg";